export const TechIcon = ({ component }: { component: React.ElementType }) => {
  const Component = component;
  return (
    <>
      <div className='size-10 [&_svg]:size-full [&_path]:!fill-[url(#tech-icon-gradient)] [&_circle]:!fill-[url(#tech-icon-gradient)] [&_rect]:!fill-[url(#tech-icon-gradient)] [&_polygon]:!fill-[url(#tech-icon-gradient)]'>
        <Component />
      </div>
      <svg className='size-0 absolute'>
        <defs>
          <linearGradient
            id='tech-icon-gradient'
            x1='0%'
            y1='0%'
            x2='0%'
            y2='100%'
          >
            <stop offset='0%' stopColor='rgb(110 231 183)' />
            <stop offset='100%' stopColor='rgb(56 189 248)' />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
